import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationScanRunCancelArgs, ScanRun } from "types/generated";

type ScanRunCancelData = {
  scanRunCancel: Pick<ScanRun, "id" | "state" | "note">;
};

export const SCAN_RUN_CANCEL: TypedDocumentNode<ScanRunCancelData, MutationScanRunCancelArgs> =
  gql`
    mutation ScanRunCancel($id: ID!, $note: String) {
      scanRunCancel(id: $id, note: $note) {
        id
        state
        note
      }
    }
  `;
